<template>
  <div class="grid-x grid">
    <div v-for="(image, index) in images" class="cell small-12 medium-6" :key="'image:' + index">
      <v-image class="image" :image="image.image" :caption="image.caption"/>
    </div>
  </div>
</template>

<script>
  import VImage from './Image.vue';
  export default {
    components: {
      VImage
    },
    props: {
      images: Array
    }
  }
</script>

<style lang="scss" scoped>
  @import 'foundation-sites/scss/foundation.scss';
  @import '@/assets/scss/_settings';
  .grid {
    @include breakpoint(medium) {
      margin: vw-relative(0 -16);
    }
  }
  .image {
    @include breakpoint(medium) {
      padding: vw-relative(0 16);
    }
  }
</style>
